import React from 'react';
import './loading-screen.css';

interface LoadingScreenProps {
  message?: string;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Loading' }) => {
  return (
    <div className="loading-screen">
      {/* Animated background elements */}
      <div className="loading-screen__background-element loading-screen__background-element--top-right"></div>
      <div className="loading-screen__background-element loading-screen__background-element--bottom-left"></div>

      {/* Main loader */}
      <div className="loading-screen__loader">
        {/* Spinner */}
        <div className="loading-screen__spinner">
          {/* Outer ring */}
          <div className="loading-screen__spinner-ring loading-screen__spinner-ring--outer"></div>
          {/* Animated ring */}
          <div className="loading-screen__spinner-ring loading-screen__spinner-ring--animated"></div>
        </div>

        {/* Text */}
        <p className="loading-screen__message">
          {message}
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
